/* eslint-disable no-unused-vars */
import { http } from 'http';

export default {
  confirmNewDriver: driverIdEncrypted =>
    http.get(`/driversweb/driversconfirmation?driverId=${driverIdEncrypted}`),

  userInfo: () => http.get('/userinfo', { withCredentials: true }),

  getLogout: () => http.get('/logout', { withCredentials: true })
};
